import { RG_TYPE as n, roundDecimals as e } from "@project-rouge/rg-core";
import { getPivotRaw as t } from "../../geometry-utils/three/index11.js";
const v = [n.Apartment, n.Core, n.Corridor, n.Entrance, n.TechnicalSpace], r = {};
function u(o) {
  if (r[o.id])
    return r[o.id];
  const p = o.apartments.all[0], f = o.rvData, l = p.children.find((i) => i.type === n.Module), d = l.children.find((i) => i.type === n.Floor), c = l.children.find((i) => i.type === n.Ceiling), s = f.find((i) => i.modulousId === o.modulousIds.defaultFlatInternalDoorId), m = {
    uuid: o.id,
    floorTop: e((1 - d.anchor[1]) * d.size[1] + l.pos[1]),
    doorTop: s ? e((1 - d.anchor[1]) * d.size[1] + s.size[1] + l.pos[1]) : 0,
    ceilingBottom: e(t([0, 0, 0], c)[1] + l.pos[1]),
    ceilingTop: e(t([0, 1, 0], c)[1] + l.pos[1])
  };
  return r[o.id] = m, r[o.id];
}
export {
  v as TypesWithLevelData,
  u as getLevelConfig,
  r as levelConfigRecord
};
//# sourceMappingURL=index2.js.map
